module.exports = __webpack_public_path__ + "img/libera.9caf24da.png";